import React, {useContext} from 'react';

const EditorContext = React.createContext();

export const useEditorContext = () => useContext(EditorContext);

export default EditorContext;
